import styled, { css } from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledDailyBonus = styled.div`
  :focus-visible {
    outline: none;
  }

  width: 100%;
  height: 100%;

  .daily-bonus-banner {
    font-family: var(--font-family), Arial;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    border-radius: 15px;
    padding: 15px;
    position: relative;
    width: inherit;
    height: inherit;

    ${(props: any) =>
      props.backgroundImage &&
      css`
        background-image: url(${props.backgroundImage});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      `}
    &__close-icon {
      padding: 10px;
      position: absolute;
      top: 0;
      right: 0;
      border: unset;
      background: unset;

      &:hover {
        cursor: pointer;
      }
    }

    &__title {
      font-size: ${(props: any) => props?.titleSize};
      font-weight: ${(props: any) => props?.titleWeight};
      color: ${(props: any) => props?.titleColor};
      margin: 33px 0 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    &__action-button {
      font-size: 24px;
      text-shadow: 0 1px 1px black;
      box-shadow: inset 0 -4px 0 rgba(0, 0, 0, 0.3);

      .stroked {
        text-decoration-line: line-through;
        text-decoration-color: #d8232a;
        text-decoration-thickness: 2px;
        display: flex;
        align-items: center;
        font-size: 20px;
      }

      &--disabled {
        cursor: default;

        img {
          margin-right: 5px;
          height: 18px;
        }
      }
    }

    &__product-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: white;
      width: 100%;

      &__product-amount {
        text-shadow: 0px 1px 1px #000;
        font-size: 20px;
        font-weight: 700;
      }
    }
  }
` as any;

export const StyledDailyBonusBadge = styled.div`
  width: 52px;
  height: 52px;
  position: relative;

  .daily-bonus-badge-banner {
    border: ${(props: any) => {
      return (
        props?.borderWidth +
          ' solid ' +
          createGradientOrSolid(props?.borderColor) || { colorOne: '#ffffff' }
      );
    }};
    border-radius: 50%;
    width: inherit;
    height: inherit;
    ${(props: any) =>
      props.badgeCoverImage &&
      css`
        background-image: url(${props.badgeCoverImage});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      `}
    &__content {
      position: relative;
      top: 2px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    &__title {
      font-size: ${(props: any) => props?.titleSize};
      font-weight: ${(props: any) => props?.titleWeight};
      color: white;
      position: relative;
      top: 10px;
      margin: 0;
      text-align: center;
      text-transform: uppercase;
      font-family: 'Lilita One', sans-serif;
      font-weight: 400;
      user-select: none;
      -webkit-text-stroke: 0.5px #1d0035;
    }
    &__action-button {
      font-size: 11px;
      background: white;
      min-height: 14px;
      line-height: 14px;
      border-radius: 3px;
      cursor: auto;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(0, 0, 0, 0.19);
      border: none;
    }
  }
` as any;
